import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=d38da820&scoped=true&"
import script from "./table-header.vue?vue&type=script&lang=ts&"
export * from "./table-header.vue?vue&type=script&lang=ts&"
import style0 from "./table-header.vue?vue&type=style&index=0&id=d38da820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38da820",
  null
  
)

export default component.exports